import { Grid } from "@mui/material";
import { AssetClass } from "../../../utils/constants";
import RegularAssetCard from "./components/cards/RegularAssetCard";
import SmartAssetCard from "./components/cards/SmartAssetCard";
import SuggestionAssetCard from "./components/cards/SuggestionAssetCard";

const AssetsGrid = ({
  allCard,
  handleOnAssetCardClick,
  chosenAsset,
  entitiesInChosenAsset,
  hasPermission,
  displayMode,
}) => {
  return (
    <Grid
      container
      sx={{
        gap: "16px 24px",
        padding: "6px",
      }}
    >
      {allCard.map((asset, index) => {
        if (asset?.asset_id !== undefined && asset?.cls === AssetClass.SMART) {
          return (
            <Grid item key={asset.asset_id}>
              <SmartAssetCard
                asset={asset}
                selected={chosenAsset?.asset_id === asset.asset_id}
                onClick={() => handleOnAssetCardClick(asset)}
                hasPermission={hasPermission}
                displayMode={displayMode}
              />
            </Grid>
          );
        }
        if (
          asset?.asset_id !== undefined &&
          asset?.cls === AssetClass.REGULAR
        ) {
          return (
            <Grid item key={asset.asset_id}>
              <RegularAssetCard
                asset={asset}
                entitiesInAsset={entitiesInChosenAsset}
                onClick={() => handleOnAssetCardClick(asset)}
                selected={chosenAsset?.asset_id === asset.asset_id}
                key={asset.asset_id}
                hasPermission={hasPermission}
                displayMode={displayMode}
              />
            </Grid>
          );
        }
        if (asset?.asset_suggestion_id) {
          return (
            <Grid item key={asset.asset_suggestion_id}>
              <SuggestionAssetCard
                suggestion={asset}
                key={asset.asset_suggestion_id}
                hasPermission={hasPermission}
              />
            </Grid>
          );
        }
        return null;
      })}
    </Grid>
  );
};

export default AssetsGrid;
